import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Loader2, Dumbbell, Flame, Film } from 'lucide-react';
import { seancesAPI } from '../services/api';
import { VideoView } from '../components/VideoView';

export default function Seances() {
  const [days, setDays] = useState(null);
  useEffect(() => { seancesAPI.unlocked().then(setDays).catch(() => setDays([])); }, []);

  if (!days) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-red-600" /></div>;

  return (
    <div className="space-y-6 animate-rise">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-red-950 dark:text-red-50">Mes séances</h1>
        <p className="text-muted-foreground text-sm mt-1">Ta bibliothèque de vidéos débloquées — rejoue-les autant que tu veux 💪</p>
      </div>

      {days.length === 0 ? (
        <Card className="p-10 rounded-2xl border-red-100 dark:border-red-900/50 flex flex-col items-center text-center gap-3">
          <Film className="w-12 h-12 text-red-300" />
          <p className="text-sm text-muted-foreground">Aucune vidéo débloquée pour l'instant.<br />Avance dans le challenge pour débloquer tes séances !</p>
        </Card>
      ) : (
        days.map((d) => (
          <Card key={d.day} className="p-5 rounded-2xl border-red-100 dark:border-red-900/50" data-testid={`seance-day-${d.day}`}>
            <Badge className="mb-3 bg-red-600 text-white rounded-full">Jour {d.day}</Badge>
            <div className="grid sm:grid-cols-2 gap-4">
              {d.session?.url && (
                <div>
                  <p className="text-sm font-semibold text-foreground flex items-center gap-1.5 mb-2"><Dumbbell className="w-4 h-4 text-red-600" />Séance sport</p>
                  <VideoView video={d.session} />
                </div>
              )}
              {d.motivation?.url && (
                <div>
                  <p className="text-sm font-semibold text-foreground flex items-center gap-1.5 mb-2"><Flame className="w-4 h-4 text-orange-500" />Motivation</p>
                  <VideoView video={d.motivation} />
                </div>
              )}
            </div>
          </Card>
        ))
      )}
    </div>
  );
}
